import { render, staticRenderFns } from "./MigrationView.vue?vue&type=template&id=9ceb423a&"
import script from "./MigrationView.vue?vue&type=script&lang=js&"
export * from "./MigrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ceb423a')) {
      api.createRecord('9ceb423a', component.options)
    } else {
      api.reload('9ceb423a', component.options)
    }
    module.hot.accept("./MigrationView.vue?vue&type=template&id=9ceb423a&", function () {
      api.rerender('9ceb423a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/migrations/MigrationView.vue"
export default component.exports